import React, { useState, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import ITEM_CODE from '../emit/utils/item_code_services.json';

const SearchInput = styled.input`
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #D0D5DD;
    font-size: 1rem;
    outline: none;
    transition: all 0.2s;
    margin-bottom: 20px;

    &:focus {
        border-color: #0088cc;
        box-shadow: 0 0 0 4px rgba(0, 136, 204, 0.1);
    }
`;

const ResultsContainer = styled.div`
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #EAECF0;
    border-radius: 8px;
`;

const ServiceItem = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid #EAECF0;
    cursor: pointer;
    transition: background 0.2s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #F9FAFB;
    }

    .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        
        .code-tag {
            background: #EFF8FF;
            color: #175CD3;
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 600;
        }

        .item-lei {
            font-weight: 700;
            color: #101828;
            font-size: 0.9rem;
        }
    }

    .description {
        font-size: 0.875rem;
        color: #475467;
        line-height: 1.4;
    }
`;

const EmptyState = styled.div`
    padding: 32px;
    text-align: center;
    color: #667085;
    
    i {
        font-size: 2rem;
        margin-bottom: 12px;
        display: block;
    }
`;

export default function ServiceFinder({ show, onHide, onSelect }) {
    const [search, setSearch] = useState('');

    const services = useMemo(() => {
        const list = [];
        Object.keys(ITEM_CODE).forEach(itemList => {
            ITEM_CODE[itemList].forEach(detail => {
                list.push({
                    itemListFree: itemList,
                    ...detail
                });
            });
        });
        return list;
    }, []);

    const filteredServices = useMemo(() => {
        if (!search) return services.slice(0, 50); // Show first 50 by default
        
        const term = search.toLowerCase();
        return services.filter(s => 
            s.itemListFree.toLowerCase().includes(term) ||
            s.code.toLowerCase().includes(term) ||
            s.service_description.toLowerCase().includes(term)
        );
    }, [search, services]);

    const handleSelect = (s) => {
        onSelect({
            item_list_service: s.itemListFree,
            service_code: s.code,
            aliq_iss: s.aliq
        });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-search-dollar me-2" style={{ color: '#0088cc' }}></i>
                    Buscador de Itens de Serviço (LC 116)
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-secondary small mb-3">
                    Pesquise por nome do serviço, código ou item da lei para preencher automaticamente os campos fiscais.
                </p>
                
                <SearchInput 
                    placeholder="Ex: Software, Limpeza, 1.04..." 
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoFocus
                />

                <ResultsContainer>
                    {filteredServices.length > 0 ? (
                        filteredServices.map((s, idx) => (
                            <ServiceItem key={idx} onClick={() => handleSelect(s)}>
                                <div className="header">
                                    <span className="item-lei">Item: {s.itemListFree}</span>
                                    <span className="code-tag">Cód: {s.code}</span>
                                </div>
                                <div className="description">
                                    {s.service_description}
                                </div>
                            </ServiceItem>
                        ))
                    ) : (
                        <EmptyState>
                            <i className="fas fa-search"></i>
                            Nenhum serviço encontrado para "{search}"
                        </EmptyState>
                    )}
                </ResultsContainer>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>Fechar</button>
            </Modal.Footer>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/components/ServiceFinder.jsx